var regions = [];
var focus = {
    regions: ["AZ", "GB", "TR", "MA", "FI", "IS", "ZA", "KZ", "UZ"]
};

function mapSelect(e, code)
{
    $(".partner-table").hide();
    $("#partner-table-" + code.toLowerCase()).show();

    var upper = $(window).scrollTop();
    var lower = upper + $(window).height();

    var target = jQuery("#partner-data").offset().top;
    if (target < upper || target > lower)
    {
        $(window).scrollTop(target);
    }
}

$(".partner-table")
    .each(function (idx, elem)
    {
        regions.push($(elem).data("country"));
    });

/* https://jvectormap.com/ */
var map = new jvm.Map({
    container: $("#partner-map"),
    map: "world_mill",
    zoomOnScroll: false,
    panOnDrag: true,
    backgroundColor: "#fff",
    focusOn: focus,
    regionStyle: {
        initial: {
            fill: "#ced0d0",
            "fill-opacity": 1,
            stroke: "none",
            "stroke-width": 1,
            "stroke-opacity": 1
        },
        hover: {
            "fill-opacity": 0.8,
            cursor: "pointer"
        },
        selected: {
            fill: "var(--site-accent)"
        }
    },
    selectedRegions: regions,
    onRegionClick: mapSelect
});

$(window)
    .resize(function ()
    {
        map.setFocus(focus);
    });